import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Zap, Users, Radio, Coins, ShieldCheck, Info } from "lucide-react";
import { Logo } from "@/components/brand/Logo";

const ROLES = [
  { icon: Zap, title: "Powering Aura", desc: "The unit of energy behind boosts, momentum and creator rewards across AuraMax." },
  { icon: Users, title: "Community", desc: "Access to creator communities, drops and gated experiences over time." },
  { icon: Radio, title: "Live & gifting", desc: "The connective layer for live gifting and real-time creator support." },
  { icon: Coins, title: "Personal coins", desc: "The ecosystem token that personal Creator Coins plug into." },
];

export default function AuramaxToken() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-3xl px-4 py-5 md:px-6">
      <button onClick={() => navigate(-1)} className="mb-4 grid h-9 w-9 place-items-center rounded-full text-white hover:bg-white/5"><ArrowLeft className="h-5 w-5" /></button>

      <div className="relative overflow-hidden rounded-3xl border border-am-border bg-am-surface/60 p-8 text-center">
        <div className="pointer-events-none absolute left-1/2 top-0 h-64 w-64 -translate-x-1/2 -translate-y-1/2 rounded-full aura-radial opacity-25 blur-3xl" />
        <div className="relative">
          <Logo size={88} className="mx-auto" />
          <h1 className="mt-5 font-mark text-4xl font-extrabold tracking-tight text-white">$AURAMAX</h1>
          <p className="mx-auto mt-2 max-w-md text-am-text2">The native token of the AuraMax ecosystem.</p>
        </div>
      </div>

      <div className="mt-5 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {ROLES.map((r) => (
          <div key={r.title} className="rounded-2xl border border-am-border bg-am-surface/60 p-5 hover-lift hover:border-am-border-strong">
            <div className="mb-3 grid h-10 w-10 place-items-center rounded-xl bg-am-surface3">
              <r.icon className="h-5 w-5 aura-text" />
            </div>
            <h3 className="mb-1 font-semibold text-white">{r.title}</h3>
            <p className="text-sm leading-relaxed text-am-text2">{r.desc}</p>
          </div>
        ))}
      </div>

      <div className="mt-4 flex items-start gap-3 rounded-2xl border border-aura-gold/25 bg-aura-gold/5 p-4">
        <Info className="mt-0.5 h-5 w-5 shrink-0 text-aura-gold" />
        <div>
          <h4 className="text-sm font-bold text-white">Not finalized</h4>
          <p className="text-sm text-am-text2">Token functionality and tokenomics are not finalized in this prototype. No supply, allocation, price, yield, returns or launch date are defined or implied.</p>
        </div>
      </div>

      <div className="mt-4 flex items-center gap-3 rounded-2xl border border-am-border bg-am-surface/60 p-4">
        <ShieldCheck className="h-5 w-5 shrink-0 text-aura-mint" />
        <p className="text-sm text-am-text2">$AURAMAX will eventually run on Solana. For now it is an informational preview of the ecosystem's future.</p>
      </div>
    </div>
  );
}
